import React from 'react';
import { CheckCircleIcon, DownloadIcon, CreditCardIcon } from 'lucide-react';
const InvoiceEmail = () => {
  return <div className="min-h-screen bg-gray-50 py-12 px-4" data-id="element-1244">
      <div className="max-w-2xl mx-auto bg-white rounded-lg shadow-lg overflow-hidden" data-id="element-1245">
        {/* Header */}
        <div className="bg-gradient-to-r from-green-600 to-emerald-600 px-8 py-10 text-center" data-id="element-1246">
          <div className="w-16 h-16 bg-white rounded-full flex items-center justify-center mx-auto mb-4" data-id="element-1247">
            <CheckCircleIcon size={32} className="text-green-600" data-id="element-1248" />
          </div>
          <h1 className="text-3xl font-bold text-white mb-2" data-id="element-1249">
            ¡Pago recibido!
          </h1>
          <p className="text-green-100" data-id="element-1250">Gracias por tu pago</p>
        </div>
        {/* Content */}
        <div className="px-8 py-10" data-id="element-1251">
          <div className="mb-8" data-id="element-1252">
            <p className="text-gray-700 text-lg mb-4" data-id="element-1253">Hola Ana,</p>
            <p className="text-gray-700 mb-4" data-id="element-1254">
              Hemos recibido exitosamente tu pago por el servicio de{' '}
              <strong data-id="element-1255">FinancePro</strong>. A continuación encontrarás los
              detalles de tu factura.
            </p>
          </div>
          {/* Invoice Details */}
          <div className="border-2 border-gray-200 rounded-lg p-6 mb-8" data-id="element-1256">
            {/* Invoice Header */}
            <div className="flex justify-between items-start mb-6 pb-6 border-b border-gray-200" data-id="element-1257">
              <div data-id="element-1258">
                <h2 className="text-2xl font-bold text-blue-600 mb-1" data-id="element-1259">
                  FinancePro
                </h2>
                <p className="text-sm text-gray-600" data-id="element-1260">CFO-as-a-Service</p>
              </div>
              <div className="text-right" data-id="element-1261">
                <p className="text-sm text-gray-500" data-id="element-1262">Factura</p>
                <p className="text-xl font-bold text-gray-800" data-id="element-1263">
                  #INV-2024-001234
                </p>
                <p className="text-sm text-gray-500 mt-1" data-id="element-1264">
                  Fecha: 15 de julio, 2024
                </p>
              </div>
            </div>
            {/* Billing Info */}
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-6 pb-6 border-b border-gray-200" data-id="element-1265">
              <div data-id="element-1266">
                <p className="text-sm font-semibold text-gray-700 mb-2" data-id="element-1267">
                  Facturado a:
                </p>
                <p className="text-gray-800 font-medium" data-id="element-1268">PYME Solutions</p>
                <p className="text-sm text-gray-600" data-id="element-1269">Ana Beltrán</p>
                <p className="text-sm text-gray-600" data-id="element-1270">
                  ana.beltran@pymesolutions.com
                </p>
                <p className="text-sm text-gray-600 mt-2" data-id="element-1271">
                  Av. Reforma 250, Piso 12
                  <br data-id="element-1272" />
                  Ciudad de México, CDMX 06600
                  <br data-id="element-1273" />
                  México
                </p>
              </div>
              <div data-id="element-1274">
                <p className="text-sm font-semibold text-gray-700 mb-2" data-id="element-1275">
                  Información de pago:
                </p>
                <div className="flex items-center space-x-2 mb-2" data-id="element-1276">
                  <CreditCardIcon size={18} className="text-gray-600" data-id="element-1277" />
                  <span className="text-sm text-gray-800" data-id="element-1278">
                    •••• •••• •••• 4242
                  </span>
                </div>
                <p className="text-sm text-gray-600" data-id="element-1279">Visa</p>
                <p className="text-sm text-gray-600 mt-2" data-id="element-1280">
                  <span className="font-medium" data-id="element-1281">Estado:</span>{' '}
                  <span className="text-green-600 font-medium" data-id="element-1282">Pagado</span>
                </p>
              </div>
            </div>
            {/* Items Table */}
            <div className="mb-6" data-id="element-1283">
              <table className="w-full" data-id="element-1284">
                <thead data-id="element-1285">
                  <tr className="border-b border-gray-200" data-id="element-1286">
                    <th className="text-left py-3 text-sm font-semibold text-gray-700" data-id="element-1287">
                      Descripción
                    </th>
                    <th className="text-center py-3 text-sm font-semibold text-gray-700" data-id="element-1288">
                      Cantidad
                    </th>
                    <th className="text-right py-3 text-sm font-semibold text-gray-700" data-id="element-1289">
                      Precio
                    </th>
                    <th className="text-right py-3 text-sm font-semibold text-gray-700" data-id="element-1290">
                      Total
                    </th>
                  </tr>
                </thead>
                <tbody data-id="element-1291">
                  <tr className="border-b border-gray-100" data-id="element-1292">
                    <td className="py-4" data-id="element-1293">
                      <p className="font-medium text-gray-800" data-id="element-1294">
                        Plan Profesional
                      </p>
                      <p className="text-sm text-gray-500" data-id="element-1295">Julio 2024</p>
                    </td>
                    <td className="text-center py-4 text-gray-700" data-id="element-1296">1</td>
                    <td className="text-right py-4 text-gray-700" data-id="element-1297">$2,499.00</td>
                    <td className="text-right py-4 text-gray-800 font-medium" data-id="element-1298">
                      $2,499.00
                    </td>
                  </tr>
                  <tr className="border-b border-gray-100" data-id="element-1299">
                    <td className="py-4" data-id="element-1300">
                      <p className="font-medium text-gray-800" data-id="element-1301">
                        Usuario adicional
                      </p>
                      <p className="text-sm text-gray-500" data-id="element-1302">Laura Torres</p>
                    </td>
                    <td className="text-center py-4 text-gray-700" data-id="element-1303">1</td>
                    <td className="text-right py-4 text-gray-700" data-id="element-1304">$299.00</td>
                    <td className="text-right py-4 text-gray-800 font-medium" data-id="element-1305">
                      $299.00
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            {/* Totals */}
            <div className="space-y-2" data-id="element-1306">
              <div className="flex justify-between text-gray-700" data-id="element-1307">
                <span data-id="element-1308">Subtotal:</span>
                <span data-id="element-1309">$2,798.00</span>
              </div>
              <div className="flex justify-between text-gray-700" data-id="element-1310">
                <span data-id="element-1311">IVA (16%):</span>
                <span data-id="element-1312">$447.68</span>
              </div>
              <div className="flex justify-between text-xl font-bold text-gray-800 pt-3 border-t-2 border-gray-300" data-id="element-1313">
                <span data-id="element-1314">Total:</span>
                <span data-id="element-1315">$3,245.68</span>
              </div>
            </div>
          </div>
          {/* Payment Confirmation */}
          <div className="bg-green-50 border border-green-200 rounded-lg p-5 mb-8" data-id="element-1316">
            <div className="flex items-start space-x-3" data-id="element-1317">
              <CheckCircleIcon size={24} className="text-green-600 flex-shrink-0 mt-0.5" data-id="element-1318" />
              <div data-id="element-1319">
                <h3 className="font-semibold text-gray-800 mb-1" data-id="element-1320">
                  Pago confirmado
                </h3>
                <p className="text-sm text-gray-700" data-id="element-1321">
                  Tu pago de <strong data-id="element-1322">$3,245.68 MXN</strong> ha sido procesado
                  exitosamente el <strong data-id="element-1323">15 de julio, 2024</strong>. Tu
                  servicio continuará sin interrupciones.
                </p>
              </div>
            </div>
          </div>
          {/* Download Button */}
          <div className="text-center mb-8" data-id="element-1324">
            <button className="inline-flex items-center space-x-2 bg-blue-600 text-white px-6 py-3 rounded-lg font-medium hover:bg-blue-700 transition-colors" data-id="element-1325">
              <DownloadIcon size={18} data-id="element-1326" />
              <span data-id="element-1327">Descargar factura (PDF)</span>
            </button>
          </div>
          {/* Next Billing */}
          <div className="bg-blue-50 border border-blue-200 rounded-lg p-5 mb-8" data-id="element-1328">
            <h3 className="font-semibold text-gray-800 mb-2" data-id="element-1329">Próximo cargo</h3>
            <p className="text-sm text-gray-700" data-id="element-1330">
              Tu próximo cargo de <strong data-id="element-1331">$3,245.68 MXN</strong> será procesado
              el <strong data-id="element-1332">15 de agosto, 2024</strong>.
            </p>
            <p className="text-sm text-gray-600 mt-2" data-id="element-1333">
              Puedes actualizar tu método de pago o cancelar tu suscripción en
              cualquier momento desde tu cuenta.
            </p>
          </div>
          {/* Support */}
          <div className="border-t border-gray-200 pt-6" data-id="element-1334">
            <p className="text-gray-600 text-sm mb-2" data-id="element-1335">
              ¿Tienes preguntas sobre tu factura?
            </p>
            <p className="text-gray-600 text-sm" data-id="element-1336">
              Contáctanos en{' '}
              <a href="mailto:facturacion@financepro.com" className="text-blue-600 hover:text-blue-700" data-id="element-1337">
                facturacion@financepro.com
              </a>
            </p>
          </div>
        </div>
        {/* Footer */}
        <div className="bg-gray-50 px-8 py-6 border-t border-gray-200" data-id="element-1338">
          <p className="text-center text-gray-600 text-sm mb-2" data-id="element-1339">
            © 2024 FinancePro. Todos los derechos reservados.
          </p>
          <p className="text-center text-gray-500 text-xs" data-id="element-1340">
            FinancePro S.A. de C.V. | RFC: FIN240101ABC | Av. Insurgentes Sur
            1234, CDMX
          </p>
        </div>
      </div>
    </div>;
};
export default InvoiceEmail;